export function extractCollectionRows(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.rows)) return data.rows;
    return [];
}

export function getChildCollections(node) {
    if (!node || typeof node !== 'object') return [];
    return node.subcategories || node.sub_collections || node.subcollections || [];
}

export function normalizeCollectionNode(node) {
    if (!node || typeof node !== 'object') return node;
    const children = getChildCollections(node);
    const subcollections = Array.isArray(children) ? children.map(normalizeCollectionNode) : [];
    return { ...node, subcollections };
}

function sortByOrder(a, b) {
    return (Number(a.order) || 0) - (Number(b.order) || 0);
}

function sortTree(node) {
    if (node.subcollections && node.subcollections.length) {
        node.subcollections = node.subcollections.sort(sortByOrder).map(sortTree);
    }
    return node;
}

export function buildCollectionTree(rows) {
    if (!rows.length) return [];
    const hasFlatParents = rows.some((r) => r.parent_id);

    if (hasFlatParents) {
        const nodes = {};
        rows.forEach((c) => {
            nodes[c.id] = { ...c, subcollections: [] };
        });

        const roots = [];
        rows.forEach((c) => {
            const node = nodes[c.id];
            if (c.parent_id && nodes[c.parent_id]) {
                nodes[c.parent_id].subcollections.push(node);
            } else {
                roots.push(node);
            }
        });
        return roots.sort(sortByOrder).map(sortTree);
    }

    return rows
        .filter((r) => !r.parent_id)
        .map(normalizeCollectionNode)
        .sort(sortByOrder)
        .map(sortTree);
}

export function filterTopLevelCollections(data) {
    const list = extractCollectionRows(data);
    return list.filter((c) => !c.parent_id);
}
